import * as keyboard from './keyboard.js';
import * as canvas from './canvas.js';
import * as ui from './ui.js';
import * as player from './player.js';
import * as audio from './audio.js';
import * as scene from './scene.js';
import * as mouse from './mouse.js';
import * as dom from './dom.js';
import * as tweens from './tweens.js';
import * as touchJoystick from './touch-joystick.js';
import * as map from './map.js';

export {
    config,
    loop,
}

window.DEVMODE = true;

// Constants
const config = {
    width: 500,
    height: 500,
};

// Variables
let timeOfLastFrame = 0;

function init() {
    dom.init();
    dom.status('Initializing...');

    canvas.init();
    keyboard.init();
    touchJoystick.init();
    mouse.init();
    audio.init();
    ui.init();
    map.init();

    dom.status('Loading...');

    scene.init().then(() => {
        dom.showMenu();
    }).catch(() => {
        dom.status('Error while loading scene...');
    });
}

function loop(time = 0) {
    const dt = (time - timeOfLastFrame) / 1000;
    update(dt);
    draw();

    timeOfLastFrame = time;

    requestAnimationFrame(loop);
}

function update(dt) {
    tweens.update(dt);
    player.update(dt);
    scene.update();
    ui.update();
}

function draw() {
    canvas.clear();
    ui.draw();
}

init();